import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
export default store => ({
  path: "exam-registration",
  exact: true,
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "exam-registration" */ "./components"),
        import(
          /* webpackChunkName: "exam-registration" */ "DPExamRegistration/modules/DPExamRegistrationModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "dpExamReg",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [],
});
